import LastMinuteJobsSubPage from "./last-minute-jobs-sub-page";


const SubPage = {
    Jobs: LastMinuteJobsSubPage,
};

export default SubPage;
